function AlignIcon({ type }) {
    const top = { w: 8 },
        mid = { w: 11 },
        bot = { w: 6 };
    const W = 20;
    const x = (w) =>
        type === 'left' ? 2 : type === 'center' ? (W - w) / 2 : W - w - 2;

    return (
        <svg
            width="20"
            height="16"
            viewBox="0 0 20 16"
            aria-hidden="true"
            className="text-current"
        >
            <rect
                x={x(top.w)}
                y="2"
                width={top.w}
                height="2"
                rx="1"
                fill="currentColor"
            />
            <rect
                x={x(mid.w)}
                y="7"
                width={mid.w}
                height="2"
                rx="1"
                fill="currentColor"
            />
            <rect
                x={x(bot.w)}
                y="12"
                width={bot.w}
                height="2"
                rx="1"
                fill="currentColor"
            />
        </svg>
    );
}

export default function AlignmentButtons({
    value,
    allowed = ['left', 'center', 'right'],
    hideUnsupported = false,
    includeOverflow = false,
    onChange,
}) {
    const ALL = includeOverflow
        ? ['left', 'center', 'right', 'left-overflow', 'right-overflow']
        : ['left', 'center', 'right'];
    const order = hideUnsupported
        ? ALL.filter((k) => allowed.includes(k))
        : ALL;

    return (
        <div className="flex flex-wrap gap-2">
            {order.map((opt) => {
                const active = value === opt;
                const disabled = !allowed.includes(opt);
                const colorClass = disabled
                    ? 'text-neutral-300'
                    : active
                    ? 'text-primary-600'
                    : 'text-neutral-500';

                const isOverflow =
                    opt === 'left-overflow' || opt === 'right-overflow';
                const label =
                    opt === 'left-overflow'
                        ? 'Left overflow'
                        : opt === 'right-overflow'
                        ? 'Right overflow'
                        : `Align ${opt}`;

                return (
                    <span
                        key={opt}
                        className={[
                            'relative inline-flex rounded-xl p-[2px]',
                            disabled ? 'bg-neutral-200' : 'bg-neutral-300',
                            'transition-colors duration-300 ease-[cubic-bezier(0.22,0.61,0.36,1)]',
                            'motion-reduce:transition-none',
                        ].join(' ')}
                    >
                        <button
                            type="button"
                            disabled={disabled}
                            onClick={() => !disabled && onChange(opt)}
                            aria-pressed={active}
                            aria-label={label}
                            className={[
                                'inline-flex h-9 items-center justify-center rounded-[10px] bg-white',
                                isOverflow ? 'px-3' : 'w-12',
                                'transition-[opacity,box-shadow] duration-300 ease-[cubic-bezier(0.22,0.61,0.36,1)]',
                                'motion-reduce:transition-none',
                                'shadow-sm',
                                !disabled && 'hover:shadow',
                                disabled && 'cursor-default opacity-50',
                                active
                                    ? 'ring-2 ring-primary-600 ring-offset-1 ring-offset-white'
                                    : 'ring-2 ring-neutral-200',
                                'focus:outline-none focus:ring-2 focus:ring-primary-600 focus:ring-offset-1',
                                colorClass,
                            ]
                                .filter(Boolean)
                                .join(' ')}
                        >
                            {isOverflow ? (
                                <span className="text-xs font-semibold capitalize">
                                    {opt.replace('-', ' ')}
                                </span>
                            ) : (
                                <AlignIcon type={opt} />
                            )}
                        </button>
                    </span>
                );
            })}
        </div>
    );
}
